import { ArrowUpRight } from "lucide-react";
import { LINKS } from "./links";

const Demo = () => (
  <section id="demo" data-testid="demo-section" className="section-pad">
    <div className="container-x">
      <p className="eyebrow mb-6">Product Demo</p>
      <h2 className="font-display max-w-2xl text-4xl leading-[1.1] tracking-tight sm:text-5xl">
        See Intuitive Shoes in action.
      </h2>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        <article
          data-testid="demo-consumer-card"
          className="card-line group flex flex-col rounded-md p-9 transition-colors duration-300 hover:border-[var(--rust)]/40"
        >
          <p className="eyebrow !text-[0.62rem]">Consumer App</p>
          <p className="mt-5 flex-1 text-base leading-relaxed text-[var(--ink-soft)]">
            Experience Intuitive Shoes from the shopper's perspective — create a
            sizing profile, explore recommendations and keep your fit history in
            one place.
          </p>
          <a
            href={LINKS.APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="demo-open-consumer-btn"
            className="btn-primary mt-8 self-start"
          >
            Open Consumer App
            <ArrowUpRight size={16} aria-hidden="true" />
          </a>
        </article>

        <article
          data-testid="demo-retailer-card"
          className="card-line group flex flex-col rounded-md p-9 transition-colors duration-300 hover:border-[var(--rust)]/40"
        >
          <p className="eyebrow !text-[0.62rem]">Retailer Experience</p>
          <p className="mt-5 flex-1 text-base leading-relaxed text-[var(--ink-soft)]">
            See how Intuitive Shoes can bring crowdsourced size recommendations
            directly into an ecommerce product page.
          </p>
          <a
            href={LINKS.RETAILER_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="demo-try-retailer-btn"
            className="btn-outline mt-8 self-start"
          >
            Try Retailer Demo
            <ArrowUpRight size={16} aria-hidden="true" />
          </a>
        </article>
      </div>
    </div>
  </section>
);

export default Demo;
